export default {
    SET_HEADER_BG: 'SET_HEADER_BG',
}


// WEBPACK FOOTER //
// ./src/_store/modules/skinModule/mutation-enum.js